export default "__VITE_ASSET__BEqVq1LC__"